// ============================================
// PRESTATIONS SECTION - Extrait de PropertyForm.jsx
// Étape 1.6: Intégration avec ctx
// Behavior: INCHANGÉ
// ============================================
import React from 'react';

/**
 * Section Prestations du formulaire de bien
 * @param {Object} ctx - Contexte partagé
 */
const PrestationsSection = ({ ctx }) => {
  const {
    formData,
    setFormData,
    handlePrestationChange,
    PRESTATIONS_LIST
  } = ctx;

  return (
    <div className="space-y-8">
      {/* Modern info header */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-purple-500/5 via-pink-500/5 to-indigo-500/10 border border-white/20 backdrop-blur-sm">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 to-pink-600/10"></div>
        <div className="relative p-6 flex items-center">
          <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center text-white mr-4 shadow-lg shadow-purple-500/25">
            <i className="bi bi-list-check text-2xl"></i>
          </div>
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-purple-600 bg-clip-text text-transparent">
              Prestations & Caractéristiques
            </h2>
            <p className="text-gray-600 font-medium">
              Sélectionnez les caractéristiques et équipements du bien
            </p>
          </div>
        </div>
      </div>

      {/* Prestations Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {(PRESTATIONS_LIST || []).map((prestation) => (
          <label
            key={prestation}
            className={`flex items-center p-4 rounded-xl border-2 cursor-pointer transition-all duration-200 ${
              formData.prestations?.[prestation]
                ? 'border-purple-500 bg-purple-50'
                : 'border-gray-200 hover:border-purple-300 bg-white'
            }`}
          >
            <input
              type="checkbox"
              checked={formData.prestations?.[prestation] || false}
              onChange={(e) => handlePrestationChange(prestation, e.target.checked)}
              className="sr-only"
            />
            <div className={`w-5 h-5 rounded-md border-2 flex items-center justify-center mr-3 transition-all ${
              formData.prestations?.[prestation]
                ? 'bg-purple-500 border-purple-500'
                : 'border-gray-300'
            }`}>
              {formData.prestations?.[prestation] && (
                <i className="bi bi-check text-white text-sm"></i>
              )}
            </div>
            <span className={`text-sm font-medium ${
              formData.prestations?.[prestation] ? 'text-purple-700' : 'text-gray-700'
            }`}>
              {prestation}
            </span>
          </label>
        ))}
      </div>

      {/* Commentaires */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Commentaires sur les prestations
        </label>
        <textarea
          value={formData.commentaires_prestations || ''}
          onChange={(e) => setFormData(prev => ({ ...prev, commentaires_prestations: e.target.value }))}
          rows={4}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Ajoutez des précisions sur les équipements et caractéristiques..."
        />
      </div>
    </div>
  );
};

export default PrestationsSection;
